export enum TournamentStatusViewType {
  Header = 'header',
  Tile = 'tile',
}
